import { gqlErrorCode, gqlErrorData, gqlMessage } from '@/lib/gql_error'
import { asJurisdictionViolation, normaliseStateCode, STATE_VIOLATION_COPY, validateState } from '@/lib/jurisdiction'

/**
 * A worker's work location (LPH-T35 FR-10, option b). The data is `WorkerArrangementModel.work_country` / `work_state`
 * (snake_case, handover §13); `ManagedWorker` has none, so the worker detail page does not show it (BE follow-up).
 */
export function workLocationLabel(a: { workCountry?: string | null; workState?: string | null }): string {
  return a.workState ?? a.workCountry ?? 'Not set'
}

/** `EM_WORKER_JURISDICTION_INVALID` by `extensions.data.violation` → the shared jurisdiction copy; else the server message. */
export function emJurisdictionErrorMessage(err: unknown, fallback: string): string {
  if (gqlErrorCode(err) === 'EM_WORKER_JURISDICTION_INVALID') {
    const v = asJurisdictionViolation(gqlErrorData(err)?.violation)
    if (v) return STATE_VIOLATION_COPY[v]
  }
  return gqlMessage(err) ?? fallback
}

/**
 * The onboarding inputs' optional `workCountry` / `workState`: normalised, omitted when empty, and validated with the same rule
 * the server applies. Returns the error copy instead when the pair is invalid.
 */
export function onboardingWorkLocation(countryRaw: unknown, stateRaw: unknown): { input: { workCountry?: string; workState?: string } } | { error: string } {
  const country = typeof countryRaw === 'string' ? normaliseStateCode(countryRaw) : ''
  // A state with no country is ignored, not an error: the state field is hidden until a country is chosen, and the form may keep
  // a value the user typed before clearing the country.
  const state = country && typeof stateRaw === 'string' ? normaliseStateCode(stateRaw) : ''
  const v = validateState(country, state)
  if (v) return { error: STATE_VIOLATION_COPY[v] }
  return { input: { ...(country ? { workCountry: country } : {}), ...(country && state ? { workState: state } : {}) } }
}
